// Il payroll fattura la competenza del mese precedente.
export const referenteVisibile = ({ nome, totale, periodi, payroll, attivita }) => {
  if (Math.abs(Number(totale) || 0) >= 0.005) return true;
  const fine = attivita.find(item => item.nome === nome)?.data_cessazione;
  if (!fine) return true;
  const match = String(fine).match(/^(\d{4})-(\d{2})/);
  if (!match) return true;
  const ultimoMese = Number(match[1]) * 12 + Number(match[2]) - 1 + (payroll ? 1 : 0);
  return periodi.some(periodo => {
    const [anno, mese] = periodo.da.split('-').map(Number);
    return anno * 12 + mese - 1 <= ultimoMese;
  });
};
